import { useState, useEffect } from 'react'
import chunk from 'lodash.chunk'

import { fetchPosts } from 'wordpress/actions'
import { chooseBestFit, extractSizes } from 'wordpress/components'
import { componentSelector } from 'wordpress/selectors'
import { withWordpressLanguage } from 'wordpress/utils'

import BackgroundContainer from './BackgroundContainer'
import SlideOut from './SlideOut'
import CustomizedSlider from './CustomizedSlider'

import '../../styles/Services.scss'

const Services = ({
    fetchPosts,
    services = [],
    itemsPerSlide,
    title,
    background,
    buttonAction,
    buttonLabel,
    page,
    url,
}) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const [selectedItemIndex, setSelectedItemIndex] = useState(null)
    const [selectedItemSlideIndex, setSelectedItemSlideIndex] = useState(null)
    const slides = chunk(services, itemsPerSlide)
    const selectedItem = selectedItemIndex === null ? 0 : slides[selectedItemSlideIndex][selectedItemIndex]
    const selectionClass = selectedItem ? 'item-selected' : ''
    const backgroundImage = chooseBestFit(
        extractSizes(selectedItem && selectedItem.backgroundImage ? selectedItem.backgroundImage : background)
    )

    useEffect(() => {
        fetchPosts('services')
    }, [fetchPosts])

    const collectBackgrounds = () => {
        const sources = {}
        services.forEach(s => {
            if (s.backgroundImage) sources[chooseBestFit(extractSizes(s.backgroundImage))] = true
        })
        return sources
    }

    const serviceBackgrounds = collectBackgrounds()

    const onServiceClick = (index, slideIndex) => {
        setSelectedItemIndex(index)
        setSelectedItemSlideIndex(slideIndex)
    }

    const onSlideChanged = slideIndex => {
        setActiveSlide(slideIndex)
    }

    const resetSelection = () => {
        setSelectedItemIndex(null)
        setSelectedItemSlideIndex(null)
    }

    if (!services.length) return null

    const viewAllBtn = label => {
        const classNames = 'btn btn-success d-block'
        return buttonAction === 'page' ? (
            <Link className={classNames} to={page} title={label}>
                {label}
            </Link>
        ) : (
            <a target="__blank" className={classNames} href={url} title={label}>
                {label}
            </a>
        )
    }

    return (
        <div>
            <div className={`container-fluid p-0 selection ${selectionClass}`} id="featured-services">
                <BackgroundContainer src={backgroundImage} images={serviceBackgrounds} />

                <div id="featured-services-slider">
                    <div className="row no-gutters">
                        <div className="header col text-center clearfix">
                            <h1>{title}</h1>
                            {viewAllBtn(buttonLabel)}
                        </div>
                    </div>

                    <CustomizedSlider
                        activeSlide={activeSlide}
                        selectedItemIndex={selectedItemIndex}
                        selectedItemSlideIndex={selectedItemSlideIndex}
                        slides={slides}
                        onServiceClick={onServiceClick}
                        onSlideChanged={onSlideChanged}
                    />
                </div>
            </div>
            <SlideOut
                item={selectedItem}
                serviceId={selectedItem ? selectedItem.service : null}
                onCloseBtnClick={resetSelection}
            />
        </div>
    )
}

export default compose(withWordpressLanguage, connect(componentSelector('services'), { fetchPosts }))(Services)
